var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.status)+" Error")]),_c('p',[_vm._v(_vm._s(_vm.reason))]),_c('p',[_vm._v(_vm._s(_vm.msg))]),_c('router-link',{attrs:{"to":"/","exact":""}},[_vm._v("\n        Go to home page\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }